/**
 * Transform general info for display on MyAccount General page
 *
 * @param generalInfo
 * @param options
 * @return {{firstName, lastName, phone, countryCode, timezone: *, language: *, locale: *}}
 */
export const transformDisplayInfo = (generalInfo, options) => {
    const { firstName, lastName, phone, phoneCountryCode, language, locale, timezone } =
        generalInfo;

    return {
        firstName,
        lastName,
        phone,
        countryCode: phoneCountryCode,
        language: options.languages[language],
        locale: options.locales[locale],
        timezone: (options.timezones.find((tz) => tz.value === timezone) ?? {})?.label,
    };
};

/**
 * Transform server response for consistent naming patterns in UI code
 * Data from the server response is different between GET and POST to ui/user/general
 * i.e. GET returns firstName while POST returns first_name
 *
 * @param generalInfo
 * @return {{firstName, lastName, phoneCountryCode, phone, timezone, language, locale}}
 */
export const transformGeneralInfo = (generalInfo = {}) => {
    // eslint-disable-next-line camelcase
    const { first_name, last_name, language, locale, phone_number, phone_country_code, timezone } =
        generalInfo;
    return {
        firstName: first_name,
        lastName: last_name,
        language,
        locale,
        timezone,
        phone: phone_number,
        phoneCountryCode: phone_country_code,
    };
};
